import { ArticulosGeneral } from '../class/articulos-general.interface';
import { ArticulosEcommerce } from './articulos-ecommerce.interface';

export interface SucursalEcommerce {
  abreviatura: string;
  barrio: string;
  calle: string;
  latitud: string;
  localidad: string;
  longitud: string;
  nombre: string;
  numero: number;
  objid: string;
  sucursal: number;
  articulos?: ArticulosGeneral[];
  urlmap: string;
  telefono?: string;
}
